export { Results as LastAddedItemMethod } from '@ori-events/loyalty-dialog-result';
export { BasketOfferTypes } from './BasketOffer';
export { ShoppingNotificationType } from './ShoppingNotification';
export const Test = 'TEST';
export const Name = 'basket-updated';
export const BasketUpdatedEvent = Name;
